<template>
  <div class="contact-us">
    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('contactUs.bannerTitle') }}
          <span></span>
        </div>
      </div>
    </div>
    <div class="content" v-if="$route.path === '/contactUs'">
      <div class="content-title">
        <div class="title">{{ $t('contactUs.title') }}</div>
        <span></span>
      </div>
      <div class="content-1">
        <div class="content-1-left">
          <div class="title">{{ $t('contactUs.zhongshanHQ') }}</div>
          <div class="content-1-item">
            <img :src="telephone">
            <span>{{ $t('contactUs.phone') }}：{{ $t('contactUs.zhongshanPhone') }}</span>
          </div>
          <div class="content-1-item">
            <img :src="email">
            <span>{{ $t('contactUs.email') }}：{{ $t('contactUs.zhongshanEmail') }}</span>
          </div>
          <div class="content-1-item">
            <img :src="address">
            <span>{{ $t('contactUs.address') }}：{{ $t('contactUs.zhongshanAddress') }}</span>
          </div>
        </div>
        <img class="content-1-right" :src="bannerUrl">
      </div>
      <div class="content-2">
        <img class="content-1-right" :src="bannerUrl">
        <div class="content-1-left">
          <div class="title">{{ $t('contactUs.shanghaiHQ') }}</div>
          <div class="content-1-item">
            <img :src="telephone">
            <span>{{ $t('contactUs.phone') }}：{{ $t('contactUs.shanghaiPhone') }}</span>
          </div>
          <div class="content-1-item">
            <img :src="email">
            <span>{{ $t('contactUs.email') }}：{{ $t('contactUs.shanghaiEmail') }}</span>
          </div>
          <div class="content-1-item">
            <img :src="address">
            <span>{{ $t('contactUs.address') }}：{{ $t('contactUs.shanghaiAddress') }}</span>
          </div>
        </div>
      </div>

      <div class="recruit">
        <div class="content-title">
          <div class="title">{{ $t('contactUs.recruit') }}</div>
          <span></span>
        </div>
        <div class="recruit-box">
          <div
            class="recruit-box-item"
            v-for="(item, index) in recruitList"
            :key="index"
            @click="recruitClick(index)"
          >
            <div class="item-top">
              <span v-if="item.urgent">{{ $t('contactUs.urgent') }}</span>
              <p>{{ item.jobName }}</p>
            </div>
            <div class="item-center">
              <span v-for="(req, idx) in item.requireList" :key="idx">{{ req }}</span>
            </div>
            <div class="item-bottom">
              {{ $t('contactUs.publishedAt') }}{{ item.createDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerUrl: require('@/assets/images/contactUs/banner.png'),
      address: require('@/assets/images/contactUs/icon_address.png'),
      email: require('@/assets/images/contactUs/icon_email.png'),
      telephone: require('@/assets/images/contactUs/icon_telephone.png'),
    }
  },
  computed: {
    recruitList () {
      return this.$t('contactUs.jobs')
    }
  },
  methods: {
    recruitClick (index) {
      document.querySelector('body').scroll(0, 650)
      this.$router.push(`/contactUs/recruit?index=${index}`)
    }
  }
}
</script>

<style scoped lang="scss">
.contact-us {
  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    background-position: top center;
    background-repeat: no-repeat;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 354px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  .content {
    .content-title {
      width: 1200px;
      margin: 0 auto;
      padding-top: 100px;
      padding-bottom: 60px;
      .title {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
      }
      span {
        display: block;
        margin-top: 16px;
        width: 80px;
        height: 4px;
        background: rgba(28, 100, 215, 1);
      }
    }
    .content-1, .content-2 {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .content-1-left {
        width: 600px;
        padding: 60px 40px;
        box-sizing: border-box;
        background: rgb(28, 100, 215);
        .title {
          font-weight: 500;
          font-size: 36px;
          line-height: 50px;
          color: #fff;
          padding-bottom: 10px;
        }
        .content-1-item {
          padding-top: 30px;
          display: flex;
          align-items: center;
          img {
            margin-right: 5px;
          }
          span {
            color: #fff;
          }
        }
      }
      .content-1-right {
        width: 600px;
        height: 400px;
        object-fit: cover;
      }
    }
    .content-2 {
      margin-top: 40px;
      .content-1-left {
        background-color: rgb(17, 44, 104);
      }
    }
    .recruit {
      margin-top: 100px;
      background-color: rgb(248, 250, 253);
      padding-bottom: 160px;
      .recruit-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .recruit-box-item {
          width: 384px;
          background-color: #fff;
          padding: 30px 40px;
          box-sizing: border-box;
          margin-right: 24px;
          margin-bottom: 24px;
          cursor: pointer;
          transition: all .6s;
          &:nth-child(3n) {
            margin-right: 0;
          }
          &:hover {
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
          }
          .item-top {
            display: flex;
            align-items: center;
            span {
              padding: 4px 7px;
              color: rgb(225, 0, 15);
              background-color: rgba(223, 0, 15, 0.1);
              border-radius: 4px;
              margin-right: 6px;
            }
            p {
              font-weight: 600;
              font-size: 24px;
              line-height: 34px;
            }
          }
          .item-center {
            margin-top: 16px;
            span {
              margin-right: 24px;
              font-weight: 400;
              font-size: 16px;
              line-height: 22px;
              color: rgba(43, 50, 71, 0.7);
            }
          }
          .item-bottom {
            margin-top: 32px;
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: rgba(43, 50, 71, 0.4);
          }
        }
      }
    }
  }
}
</style>
